import React from "react";
import { Link } from "react-router-dom";
import ClientPortalLayout from "./ClientPortalLayout";

const ClientDeliveryTracking = () => {
  return (
    <ClientPortalLayout
      activeKey="delivery"
      title="Delivery Tracking"
      subtitle="Track courier dispatch status and proof of delivery."
      actions={<><Link className="btn btn-light" to="/client-downloads">Download POD</Link><Link className="btn btn-light" to="/client-dashboard">Dashboard</Link></>}
    >
      <article className="table-panel">
        <div className="search-row">
          <input type="text" placeholder="Search by notice id, tracking id, status" />
          <input type="text" placeholder="Filter by courier" />
          <select><option>All Status</option><option>Delivered</option><option>In Transit</option><option>Out for Delivery</option></select>
        </div>
        <div className="table-scroll">
          <table className="crud-table">
            <thead><tr><th>Notice ID</th><th>Courier</th><th>Tracking ID</th><th>Dispatch Date</th><th>Status</th><th>Proof of Delivery</th></tr></thead>
            <tbody>
              <tr><td>LN-2028</td><td>BlueDart</td><td>TRK-88091</td><td>2026-02-28</td><td>Delivered</td><td><button className="tiny-btn">&#9998;</button></td></tr>
              <tr><td>LN-2026</td><td>Delhivery</td><td>TRK-88075</td><td>2026-03-01</td><td>In Transit</td><td><button className="tiny-btn">&#9998;</button></td></tr>
              <tr><td>LN-2022</td><td>DTDC</td><td>TRK-88012</td><td>2026-02-22</td><td>Delivered</td><td><button className="tiny-btn">&#9998;</button></td></tr>
            </tbody>
          </table>
        </div>
      </article>
      <div className="pagination-wrap"><p className="pagination-meta">Showing 1-25 of 300</p><div className="pagination"><span className="page-btn active">1</span><span className="page-btn">2</span><span className="page-btn">3</span><span className="page-btn">...</span><span className="page-btn">16</span></div></div>
    </ClientPortalLayout>
  );
};

export default ClientDeliveryTracking;
